import React from 'react'

export function ChatBotFooter() {
    return (
        <div>
            <span>Powered By </span>
            <b>UnityPredict</b>
        </div>
    )
}
